import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import {Context} from './Context';
import {PanelBar, PanelBarItem} from '@progress/kendo-react-layout';

class Sidebar extends Component {
	render() {
		return (
			<Context.Consumer>
				{({logout, user}) => (
					<nav id="sidebar">
						<div id="sidebarUser">
							<div className="k-icon k-i-user"></div>
							<div>Willkommen {user.salutation + " " + user.lastname}!</div>
						</div>
						<PanelBar onSelect={this.onSelect}>
							{user.rolesVisible.map(role => (
								<PanelBarItem icon={role.icon} key={role.title} route={role.url} title={role.title}>
									{role.items.length && role.items.map(roleChild => (
										<PanelBarItem icon={roleChild.icon} key={roleChild.title} route={roleChild.url} title={roleChild.title} />
									))}
								</PanelBarItem>
							))}
						</PanelBar>
						<div id="sidebarLogout">
							<Link onClick={logout} to='/Login'>Ausloggen &raquo;</Link>
						</div>
						<div id="versionNrField">
							Version: {window.variables.version}
						</div>
					</nav>
				)}
			</Context.Consumer>
		);
	}
	onSelect = (event) => {
		this.props.history.push(event.target.props.route);
	}
}

export default withRouter(Sidebar);
